import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_ALL_REPORTS = restRequest("HSQEREPORT.GET_ALL_REPORTS");
export const GET_JOBPACK_REPORTS = restRequest("HSQEREPORT.GET_JOBPACK_REPORTS");
export const SET_MONTH = "HSQEREPORT.SET_MONTH";
export const SET_YEAR = "HSQEREPORT.SET_YEAR";
export const GET_HSQE_TEMPLATE = restRequest(
    "HSQEREPORT.GET_HSQE_TEMPLATE"
);
export const SET_SPECIFIC_TEMPLATE = restRequest(
    "HSQEREPORT.SET_SPECIFIC_TEMPLATE"
);
export const GET_USERS_PROFILE = restRequest(
    "HSQEREPORT.GET_USERS_PROFILE"
);
